/**
 * HQ 이용권 만료 임박 현황 서비스. (대표 전용 — 백엔드에서 hq_admin 게이트)
 * 집계 단위는 학생 — 이미 연장한 학생은 제외된다.
 */
import hqApi from './hqApiClient';

export interface ExpiryStore {
  organization_id: string;
  name: string;
  alimtalk_expiry_on: boolean;
  alimtalk_master_on: boolean;
  gate_block_expired: boolean;
  already_expired: number;
  within_7: number;
  within_14: number;
  active_valid: number;
}

export interface ExpirySummary {
  today: string;
  stores: ExpiryStore[];
  totals: {
    already_expired: number;
    within_7: number;
    within_14: number;
    active_valid: number;
    alimtalk_off_count: number;
  };
  note: string;
}

export interface ExpiryMember {
  name: string;
  voucher_name: string | null;
  expiry_date: string;
  days_left: number;
}

export interface ExpiryStoreDetail {
  organization_id: string;
  name: string;
  today: string;
  members: ExpiryMember[];
}

export const hqExpiryService = {
  async summary(): Promise<ExpirySummary> {
    const { data } = await hqApi.get<ExpirySummary>('/api/v1/hq/expiry/summary');
    return data;
  },

  async storeMembers(organizationId: string, days = 14): Promise<ExpiryStoreDetail> {
    const { data } = await hqApi.get<ExpiryStoreDetail>(
      `/api/v1/hq/expiry/store/${organizationId}`,
      { params: { days } },
    );
    return data;
  },
};
